import { AlertAction } from './alert-action.model';

export enum AlertType {
  SUCCESS = 'success',
  INFO = 'info',
  WARNING = 'warning',
  ERROR = 'error',
}

export enum PersistenceLevel {
  NONE = 'none',
  SESSION = 'session',
  CRITICAL = 'critical',
  STICKY = 'sticky',
}

export interface Alert {
  id: string;
  type: AlertType;
  title: string;
  message: string;
  timestamp: Date;
  dismissible: boolean;
  duration?: number;
  persistence: PersistenceLevel;
  actions?: AlertAction[];
  metadata?: Record<string, unknown>;
  progress?: number;
}
